import React, { useEffect, useState } from 'react';
import { IDocument } from '../../../../../Interfaces/IDocument';
import { Box, Button, Grid, Typography } from '@mui/material';
import { DocumentOverview } from '../../../../Document/DocumentOverview';
import { ICompanyFormationAnswer } from '../../../../../Interfaces/ICompanyFormationAnswer';
import { ICompanyFormationQuestion } from '../../../../../Interfaces/ICompanyFormationQuestion';
import { ICompanyFormationOption } from '../../../../../Interfaces/ICompanyFormationOption';
import { getCompanyFormationAnswer } from '../../Founding/companyFormation_helpers';
import { addUpdateAnswerArray } from './RARepresentative';
import { useTranslation } from 'react-i18next';
import { checkTranslation } from '../../../../core/standardFunctions';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

interface IProps {
  handleBack: Function;
  handleNext: Function;
  documentArray: IDocument[];
  setDocumentArray: Function;
  companyFormationAnswerArray: ICompanyFormationAnswer[];
  setCompanyFormationAnswerArray: Function;
  companyFormationQuestionArray: ICompanyFormationQuestion[];
  companyFormationOptionArray: ICompanyFormationOption[];

  //Für CompanyChange Buttons deaktiveren
  buttonsDisabled?: boolean;
}

export const RAConstitution: React.FC<IProps> = props => {
  const { t } = useTranslation();
  const currentYear = dayjs();

  const [companyAnswerDateOfConsitution, setCompanyAnswerDateOfConsitution] =
    useState(
      getCompanyFormationAnswer(9, props.companyFormationAnswerArray, 28)
    );

  useEffect(() => {
    props.setCompanyFormationAnswerArray(
      addUpdateAnswerArray(
        props.companyFormationAnswerArray,
        companyAnswerDateOfConsitution
      )
    );
  }, [companyAnswerDateOfConsitution]);

  const handleDateChange = (newValue: dayjs.Dayjs | null) => {
    if (newValue) {
      const dateString = newValue.format('YYYY-MM-DD');
      setCompanyAnswerDateOfConsitution({
        ...companyAnswerDateOfConsitution,
        TextValue: dateString,
      });
    } else {
      setCompanyAnswerDateOfConsitution({
        ...companyAnswerDateOfConsitution,
        TextValue: null,
      });
    }
  };

  return (
    <>
      <Box sx={{ mt: 5 }} />
      <Typography variant='h4' sx={{ mb: 3 }}>
        {checkTranslation(t, 'association_articles', 'Satzung des Vereins')}
      </Typography>

      <Grid container spacing={2}>
        <Grid item sm={12}>
          <Typography variant='h6'>
            {checkTranslation(t, 'association_articles_date', 'Satzungsdatum')}
          </Typography>
        </Grid>

        <Grid item sm={12}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='de'>
            <DatePicker
              label={checkTranslation(
                t,
                'association_articles_date',
                'Satzungsdatum'
              )}
              maxDate={currentYear}
              openTo='year'
              views={['year', 'month', 'day']}
              value={
                companyAnswerDateOfConsitution.TextValue
                  ? dayjs(companyAnswerDateOfConsitution.TextValue)
                  : null
              }
              onChange={handleDateChange}
              slotProps={{
                textField: {
                  size: 'small',
                  fullWidth: true,
                  required: true,
                  error: companyAnswerDateOfConsitution.TextValue === null,
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>

      <Typography variant='h6' sx={{ mt: 10 }}>
        {checkTranslation(
          t,
          'association_articles_documents',
          'Satzungs- und Gründungsdokumente'
        )}
      </Typography>
      <Typography sx={{ mb: 3 }} component={'span'} variant={'body2'}>
        <u>
          {checkTranslation(
            t,
            'association_articles_upload',
            'Bitte laden Sie die Satzung Ihres Vereins hoch.'
          )}
        </u>
        <br />
        {checkTranslation(
          t,
          'association_articles_upload_addition',
          'Ergänzend können Sie weitere Dokumente aus dem Gründungsprozess hochladen, um eine schnelle Bearbeitung sicherzustellen.'
        )}
      </Typography>
      <DocumentOverview
        allowRemove
        allowUpload
        documentArray={props.documentArray}
        setDocumentArray={props.setDocumentArray}
        title=''
      />
      {(props.buttonsDisabled === undefined || !props.buttonsDisabled) && (
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 10 }}>
          <Button
            variant='outlined'
            onClick={() => props.handleBack()}
            sx={{ mr: 1 }}
          >
            {checkTranslation(t, 'button_back', 'Zurück')}
          </Button>
          <Box sx={{ flex: '1 1 auto' }} />
          <Button
            type='submit'
            variant='contained'
            disabled={companyAnswerDateOfConsitution.TextValue === null}
            onClick={() => props.handleNext()}
          >
            {checkTranslation(t, 'button_next', 'Weiter')}
          </Button>
        </Box>
      )}
    </>
  );
};
